<div class="group__filter" [formGroup]="formDate">
  <div class="tb-padding--right">
    <div class="form-group">
      <!-- <span class="mr-4 filter-title">{{titleStart || 'Từ ngày'}} 
        <span *ngIf="isRequired" style="color: red;">(*)</span>
      </span> -->
      <div class="d-flex align-items-center">
        <div id="start-date" class="input-group d-flex flex-column ">
          <div class="input-group">
            <input-date [value]="formDate.value.startDate" (result)="emitInputDate('startDate', $event)"
              placeholder="Ngày bắt đầu" [isNoFuture]="isNoFuture" [isNoPast]="isNoPast" [disabled]="isDisabledStart">
            </input-date>
          </div>
        </div>
      </div>

      <div class="d-flex">
        <span *ngIf="isRequired && isValidated && !formDate.value.startDate" style="color: red;">Dữ liệu bắt buộc
          nhập</span>
      </div>

    </div>
  </div>
  <div class="tb-padding--right">
    <div class="form-group">
      <!-- <span class="mr-3 filter-title">{{titleEnd || 'Đến ngày'}}
        <span *ngIf="isRequired" style="color: red;">(*)</span>
      </span> -->
      <div class="d-flex align-items-center">
        <div id="end-date" class="input-group d-flex flex-column">
          <div class="input-group">
            <input-date [value]="formDate.value.endDate" (result)="emitInputDate('endDate', $event)"
              placeholder="Ngày kết thúc" [isNoFuture]="isNoFuture" [isNoPast]="isNoPast" [disabled]="isDisabledEnd">
            </input-date>
          </div>
        </div>
      </div>
      <div class="d-flex">
        <span *ngIf="isRequired && isValidated && !formDate.value.endDate" style="color: red;">Dữ liệu bắt buộc
          nhập</span>
      </div>
    </div>
  </div>
</div>